import React from 'react';

const AboutUs: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>About Flow</h1>
        <p className="page-subtitle">Writing reimagined for the modern world</p>
      </div>

      <div className="page-content">
        <section className="content-section">
          <h2>Our Mission</h2>
          <p>
            At Flow, we believe that great writing should be effortless and accessible to everyone.
            Our platform combines the power of modern technology with the timeless art of storytelling
            to create an unparalleled writing experience.
          </p>
        </section>

        <section className="content-section">
          <h2>What We Do</h2>
          <p>
            Flow is a comprehensive writing platform that empowers creators, journalists, bloggers,
            and writers of all kinds to craft compelling content. With our intuitive editor,
            collaborative features, and publishing tools, we make it easy to bring your ideas to life
            and share them with the world.
          </p>
        </section>

        <section className="content-section">
          <h2>Our Vision</h2>
          <p>
            We envision a world where every voice can be heard and every story can be told.
            Through Flow, we're building a community of writers who inspire, inform, and connect
            with readers across the globe. Our platform is designed to break down barriers and
            make quality publishing accessible to all.
          </p>
        </section>

        <section className="content-section">
          <h2>Why Choose Flow?</h2>
          <ul>
            <li><strong>Intuitive Design:</strong> Our clean, distraction-free interface lets you focus on what matters most - your writing.</li>
            <li><strong>Powerful Features:</strong> From markdown support to collaborative editing, we provide the tools you need to create exceptional content.</li>
            <li><strong>Community Focused:</strong> Connect with fellow writers, share feedback, and grow together in our supportive community.</li>
            <li><strong>Performance Optimized:</strong> Lightning-fast loading times and seamless publishing ensure your content reaches readers without delay.</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>Join the Flow Community</h2>
          <p>
            Whether you're a seasoned writer or just starting your journey, Flow provides the
            perfect environment to nurture your craft and share your unique perspective with the world.
            Join thousands of writers who have already discovered the power of Flow.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;